<template>
  <div>
    <div class="potential-tip">
      <div>
        1.挑选复购商品是系统自动为您挑选出未加入复购提醒计划但已产生复购的商品
      </div>
      <div>
        2.实际复购次数较高的潜力商品加入到复购提醒计划中会大幅提升复购率
      </div>
      <div>3.为了避免骚扰，1个商品只能同时参与1个进行中的复购提醒计划</div>
    </div>
    <hm-content title="">
      <div class="table-panel flex flex-end">
        <el-input
          clearable
          style="width: 300px"
          v-model.trim="searchCondition.spuName"
          size="small"
          placeholder="请输入商品名称"
          class="ipt mr10"
        >
        </el-input>
        <el-button type="primary" size="small" @click="search">查询</el-button>
      </div>
      <div>
        <el-table
          stripe
          border
          ref="btable"
          :data="list"
          style="width: 100%"
          id="table"
          size="small"
          @sort-change="sortChange"
          :default-sort="{ prop: 'num', order: 'descending' }"
        >
          <el-table-column
            type="index"
            label="序号"
            :index="(index) => index + (currentPage - 1) * pageSize + 1"
          ></el-table-column>
          <el-table-column
            header-align="left"
            align="left"
            prop="spuName"
            label="商品名称"
            show-overflow-tooltip
            width="420"
          ></el-table-column>
          <el-table-column
            header-align="left"
            align="left"
            prop="goodsSn"
            label="货号"
          ></el-table-column>
          <!-- <el-table-column
            header-align="left"
            align="left"
            prop="specBarcode"
            label="条码"
          ></el-table-column> -->
          <el-table-column
            header-align="left"
            align="left"
            prop="specIdGroupName"
            label="规格"
          ></el-table-column>
          <el-table-column
            header-align="left"
            align="left"
            prop="categoryName"
            label="分类"
          ></el-table-column>
          <el-table-column
            header-align="left"
            align="left"
            prop="repurchaseCycleNum"
            label="单品复购周期（取整数部分）"
          >
            <template slot="header">
              单品复购周期（取整数部分）
              <el-tooltip
                class="tooltip"
                effect="light"
                content="手动设置的单品使用周期，仅取整数部分"
                placement="top"
              >
                <i class="el-icon-question" style="font-size: 18px"></i>
              </el-tooltip>
            </template>
            <template slot-scope="scope">
              <div @click="setting(scope.row)" class="pointer">
                <i style="font-size: 16px" class="el-icon-setting blue"></i>
                <span :class="scope.row.repurchaseCycleNum ? '' : 'gray'">{{
                  scope.row.repurchaseCycleNum
                    ? scope.row.repurchaseCycleNum + "天"
                    : " 未设置"
                }}</span>
              </div>
            </template>
          </el-table-column>
          <el-table-column
            header-align="left"
            align="left"
            prop="spuName"
            label="近1个月实际复购周期区间"
          >
            <template slot="header">
              近1个月实际复购周期区间
              <el-tooltip
                class="tooltip"
                effect="light"
                content="系统根据消费者在店铺的购买行为计算得来的复购周期"
                placement="top"
              >
                <i class="el-icon-question" style="font-size: 18px"></i>
              </el-tooltip>
            </template>
            <template slot-scope="scope">
              <div v-if="scope.row.repurchaseCycleMinValue">
                {{ scope.row.repurchaseCycleMinValue }}天-{{
                  scope.row.repurchaseCycleMaxValue
                }}天
              </div>
            </template>
          </el-table-column>
          <el-table-column
            header-align="left"
            align="left"
            prop="repurchaseMemberNum"
            label="已产生复购人数"
            sortable="custom"
          >
            <template slot-scope="scope">
              {{ scope.row.repurchaseMemberNum }}人
            </template>
          </el-table-column>
          <el-table-column
            header-align="left"
            align="left"
            prop="joinPlanNum"
            label="参与中提醒计划数"
          >
            <template slot-scope="scope">
              <div
                v-if="scope.row.joinPlanNum > 0"
                class="blue pointer"
                @click="detailPlan(scope.row)"
              >
                {{ scope.row.joinPlanNum }}
              </div>
              <div v-else>
                {{ scope.row.joinPlanNum }}
              </div>
            </template>
          </el-table-column>
          <el-table-column
            header-align="center"
            align="left"
            label="操作"
            width="180"
          >
            <template slot-scope="scope">
              <el-button
                size="small"
                class="blue"
                type="text"
                @click="toDetails(scope.row)"
                >查看详情</el-button
              >
              <el-divider direction="vertical"></el-divider>
              <el-button
                size="small"
                :class="!scope.row.repurchaseCycleNum ? 'gray' : 'blue'"
                type="text"
                :disabled="!scope.row.repurchaseCycleNum"
                @click="addToPlan(scope.row)"
                >添加到推送计划</el-button
              >
            </template>
          </el-table-column>
        </el-table>
        <div class="hm-pagination">
          <el-pagination
            background
            :total="total"
            @current-change="paging"
            @size-change="handleSizeChange"
            layout="total, sizes, prev, pager, next, jumper"
            :current-page="currentPage"
          ></el-pagination>
        </div>
      </div>
    </hm-content>
    <el-dialog
      :close-on-click-modal="false"
      title="添加到推送计划"
      :visible.sync="dialogVisible"
      width="1000px"
    >
      <div class="flex flex-end mb10">
        <el-input
          type="text"
          class="mr10"
          v-model.trim="searchConditionPlan.planName"
          clearable
          placeholder="请输入计划名称"
          size="small"
        ></el-input>
        <el-date-picker
          clearable
          v-model="searchConditionPlan.createTimeArry"
          type="daterange"
          align="right"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          value-format="yyyy-MM-dd"
          size="small"
          class="mr10"
        ></el-date-picker>
        <el-button type="primary" size="small" @click="searchPlan"
          >查询</el-button
        >
      </div>
      <div>
        <el-table
          stripe
          border
          ref="btable"
          :data="listPlan"
          style="width: 100%"
          id="table"
          size="small"
        >
          <el-table-column
            type="index"
            label="序号"
            :index="(index) => index + (currentPagePlan - 1) * pageSizePlan + 1"
          ></el-table-column>
          <el-table-column
            header-align="center"
            align="center"
            prop="planName"
            label="计划名称"
          >
          </el-table-column>
          <el-table-column
            header-align="center"
            align="center"
            prop="planStartDate"
            label="计划时间"
          >
            <template slot-scope="scope">
              {{ scope.row.planStartDate }}至{{ scope.row.planEndDate }}
            </template>
          </el-table-column>
          <el-table-column
            header-align="center"
            align="center"
            prop="spuName"
            label="状态"
          >
            <template slot-scope="scope">
              <div v-if="scope.row.planStatus === 'notStart'" class="gray">
                未开始
              </div>
              <div
                v-else-if="scope.row.planStatus === 'running'"
                class="success"
              >
                进行中
              </div>
              <div v-else-if="scope.row.planStatus === 'end'" class="gray">
                已结束
              </div>
              <div
                v-else-if="scope.row.planStatus === 'errorStop'"
                class="danger"
              >
                异常暂停
              </div>
              <div v-else-if="scope.row.planStatus === 'stop'" class="orange">
                暂停
              </div>
            </template>
          </el-table-column>
          <el-table-column
            header-align="center"
            align="center"
            label="操作"
            width="200"
          >
            <template slot-scope="scope">
              <el-button
                size="small"
                class="blue"
                type="text"
                @click="addPlan(scope.row)"
                >添加到计划</el-button
              >
            </template>
          </el-table-column>
        </el-table>
        <div class="hm-pagination">
          <el-pagination
            background
            :total="totalPlan"
            @current-change="pagingPlan"
            @size-change="handleSizeChangePlan"
            layout="total, sizes, prev, pager, next, jumper"
            :current-page="currentPagePlan"
          ></el-pagination>
        </div>
      </div>
    </el-dialog>
    <el-dialog
      :close-on-click-modal="false"
      title="参与中的计划"
      :visible.sync="dialogVisiblePlan"
      width="1000px"
    >
      <div>
        <el-table
          stripe
          border
          ref="btable"
          :data="joinPlanList"
          style="width: 100%"
          id="table"
          size="small"
        >
          <el-table-column
            type="index"
            label="序号"
            :index="(index) => index + (currentPagePlan - 1) * pageSizePlan + 1"
          ></el-table-column>
          <el-table-column
            header-align="center"
            align="center"
            prop="planName"
            label="计划名称"
          >
          </el-table-column>
          <el-table-column
            header-align="center"
            align="center"
            prop="planStartDate"
            label="计划时间"
          >
            <template slot-scope="scope">
              {{ scope.row.planStartDate }}至{{ scope.row.planEndDate }}
            </template>
          </el-table-column>
          <el-table-column
            header-align="center"
            align="center"
            prop="spuName"
            label="状态"
          >
            <template slot-scope="scope">
              <div v-if="scope.row.planStatus === 'notStart'" class="gray">
                未开始
              </div>
              <div
                v-else-if="scope.row.planStatus === 'running'"
                class="success"
              >
                进行中
              </div>
              <div v-else-if="scope.row.planStatus === 'end'" class="gray">
                已结束
              </div>
              <div
                v-else-if="scope.row.planStatus === 'errorStop'"
                class="danger"
              >
                异常暂停
              </div>
              <div v-else-if="scope.row.planStatus === 'stop'" class="orange">
                暂停
              </div>
            </template>
          </el-table-column>
        </el-table>
        <div class="hm-pagination">
          <el-pagination
            background
            :total="totalPlan"
            @current-change="pagingPlan"
            @size-change="handleSizeChangePlan"
            layout="total, sizes, prev, pager, next, jumper"
            :current-page="currentPagePlan"
          ></el-pagination>
        </div>
      </div>
    </el-dialog>
    <hm-batch-purchase-cycle
      :visible="dialogVisibleBatch"
      @close="dialogVisibleBatch = false"
      @confirm="confirm"
      title="编辑复购周期"
      ref="purchasecycle"
      :goodsName="row.spuName"
    >
    </hm-batch-purchase-cycle>
  </div>
</template>

<script>
import HmBatchPurchaseCycle from "@/components/HmBatchPurchaseCycle";
export default {
  components: { HmBatchPurchaseCycle },
  data() {
    return {
      joinPlanList: [],
      dialogVisiblePlan: false,
      dialogVisibleBatch: false,
      totalPlan: 0,
      listPlan: [],
      pageSizePlan: 10,
      currentPagePlan: 1,
      searchConditionPlan: {},
      dialogVisible: false,
      total: 0,
      list: [],
      pageSize: 10,
      currentPage: 1,
      searchCondition: {},
      row: {},
      sort: {}
    };
  },
  computed: {},
  watch: {},
  created() {},
  mounted() {
    this.queryList();
  },
  methods: {
    detailPlan(row) {
      this.row = row;
      this.dialogVisiblePlan = true;
      this.currentPagePlan = 1;
      this.pageSizePlan = 10;
      this.queryJoinPlanList();
    },
    async queryJoinPlanList() {
      const params = {
        pageSize: this.pageSizePlan,
        pageNo: this.currentPagePlan,
        skuId: this.row.skuId
      };
      const searchCondition = JSON.parse(
        JSON.stringify(this.searchConditionPlan)
      );
      Object.assign(params, searchCondition);
      const { code, result } = await this.$store.dispatch(
        "queryPotentialSkuJoinPlanList",
        params
      );
      if (code === "0") {
        const { total, records } = result;
        this.joinPlanList = records;
        this.totalPlan = total;
      }
    },
    sortChange(sort) {
      this.sort = sort;
      this.queryList();
    },
    async addPlan(row) {
      const { code } = await this.$store.dispatch("addToRepurchasePlan", {
        planId: row.id,
        skuId: this.row.skuId,
        specIdGroupName: this.row.specIdGroupName
      });
      if (code === "0") {
        this.$message({
          message: "操作成功！",
          type: "success"
        });
        this.dialogVisible = false;
        this.queryList();
      }
    },
    confirm(val) {
      if (this.row.repurchaseCycleNum) {
        let params = {
          id: this.row.repurchaseSkuId,
          repurchaseCycleNum: val
        };

        this.$store
          .dispatch("editRepurchaseSkuCycleValue", params)
          .then(res => {
            if (res.code === "0") {
              this.$message({
                message: "操作成功！",
                type: "success"
              });
              this.queryList();
              this.dialogVisibleBatch = false;
            }
          });
      } else {
        this.row.repurchaseCycleNum = val;

        let repurchaseSkuInfoModels = [this.row];

        this.$store
          .dispatch("batchSaveRepurchaseSku", { repurchaseSkuInfoModels })
          .then(res => {
            if (res.code === "0") {
              this.$message({
                message: "操作成功！",
                type: "success"
              });
              this.queryList();
              this.dialogVisibleBatch = false;
            }
          });
      }
    },
    setting(row) {
      this.row = JSON.parse(JSON.stringify(row));
      this.dialogVisibleBatch = true;
      this.$refs.purchasecycle.repurchaseCycleNum = row.repurchaseCycleNum;
    },
    isArray(arr) {
      return Object.prototype.toString.call(arr) === "[object Array]";
    },
    async queryPlanList() {
      const params = {
        pageSize: this.pageSizePlan,
        pageNo: this.currentPagePlan,
        skuId: this.row.skuId
      };
      const searchCondition = JSON.parse(
        JSON.stringify(this.searchConditionPlan)
      );
      searchCondition.queryStartTime = this.isArray(
        this.searchConditionPlan.createTimeArry
      )
        ? searchCondition.createTimeArry[0]
        : "";
      searchCondition.queryEndTime = this.isArray(
        this.searchConditionPlan.createTimeArry
      )
        ? searchCondition.createTimeArry[1]
        : "";
      Object.assign(params, searchCondition);
      const { code, result } = await this.$store.dispatch(
        "queryRepurchasePlanInfoPageList",
        params
      );
      if (code === "0") {
        const { total, records } = result;
        this.listPlan = records;
        this.totalPlan = total;
      }
    },
    pagingPlan(page) {
      this.currentPagePlan = page;
      if (this.dialogVisiblePlan) {
        this.queryJoinPlanList();
      } else {
        this.queryPlanList();
      }
    },
    handleSizeChangePlan(size) {
      this.currentPagePlan = 1;
      this.pageSizePlan = size;
      if (this.dialogVisiblePlan) {
        this.queryJoinPlanList();
      } else {
        this.queryPlanList();
      }
    },
    searchPlan() {
      this.currentPagePlan = 1;
      this.queryPlanList();
    },
    addToPlan(row) {
      this.row = row;
      this.dialogVisible = true;
      this.currentPagePlan = 1;
      this.pageSizePlan = 10;
      this.queryPlanList();
    },
    toDetails(row) {
      this.$router.push({
        name: "PotentialGoodsOrder",
        query: {
          row: JSON.stringify(row)
        }
      });
    },
    async queryList() {
      const params = {
        pageSize: this.pageSize,
        pageNo: this.currentPage
      };
      const searchCondition = JSON.parse(JSON.stringify(this.searchCondition));
      if (this.sort.order === "descending") {
        searchCondition.sortBy = "desc";
      } else if (this.sort.order === "ascending") {
        searchCondition.sortBy = "asc";
      }

      Object.assign(params, searchCondition);
      const { code, result } = await this.$store.dispatch(
        "queryStorePotentialSkuInfoList",
        params
      );
      if (code === "0") {
        const { total, records } = result;
        this.list = records;
        this.total = total;
      }
    },
    paging(page) {
      this.currentPage = page;
      this.queryList();
    },
    handleSizeChange(size) {
      this.currentPage = 1;
      this.pageSize = size;
      this.queryList();
    },
    search() {
      this.currentPage = 1;
      this.queryList();
    }
  }
};
</script>
<style lang='scss' scoped>
.potential-tip {
  padding: 15px;
  color: #0081e5;
  background: #e8f5ff;
  border: 1px solid #0081e5;
  font-size: 14px;
  margin-bottom: 10px;
  > div {
    line-height: 20px;
  }
}
</style>
